/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Child_Age_Notice_OneInputs */

const en_search_child_age_notice_one = /** @type {(inputs: Search_Child_Age_Notice_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick your child's age to include them in these results.`)
};

/**
* | output |
* | --- |
* | "Pick your child's age to include them in these results." |
*
* @param {Search_Child_Age_Notice_OneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_child_age_notice_one = /** @type {((inputs?: Search_Child_Age_Notice_OneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Child_Age_Notice_OneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_child_age_notice_one(inputs)
});